import React from "react";
import { Form } from "react-bootstrap";

const PageSizeSelector = ({ pageSize, onChange, options = [] }) => {
  return (
    <Form.Select
      size="sm"
      value={pageSize}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-auto ps-4 pe-5"
    >
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </Form.Select>
  );
};

export default PageSizeSelector;
